import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Divider } from '@kambi/spark';

import classes from '../../App.module.css';
import {
    GET_POTENTIAL_PAYOUT_ROUTE,
    ORIGINAL_POTENTIAL_PAYOUT_ROUTE,
    POTENTIAL_PAYOUT_SYSTEM_ROUTE,
} from './constants/PotentialPayoutConstants';
import Description from './components/PotentialPayoutDescription';
import UtilsList from 'components/layout/utils-list/UtilsList';

const PotentialPayout = () => {
    const navigate = useNavigate();
    const potentialPayoutUtils = [
        {
            label: 'getPotentialPayout',
            path: GET_POTENTIAL_PAYOUT_ROUTE,
        },
        {
            label: 'getOriginalPotentialPayout',
            path: ORIGINAL_POTENTIAL_PAYOUT_ROUTE,
        },
        {
            label: 'getPotentialPayoutSystem',
            path: POTENTIAL_PAYOUT_SYSTEM_ROUTE,
        },
    ];
    return (
        <div className={classes.Wrapper}>
            <Button
                color="primary"
                variant="outlined"
                onClick={() => navigate('/')}
            >
                Back
            </Button>
            <div className={classes.Divider}>
                <Divider />
            </div>
            <div className={classes.Content}>
                <div className={classes.Main}>
                    <Description />
                    <Divider />
                </div>
                <UtilsList props={potentialPayoutUtils} />
            </div>
        </div>
    );
};

export default PotentialPayout;
